<template>
    <div class="page-content vertical-align-middle">
      <header>
        <h1 class="animation-slide-top">404</h1>
        <p>Página no encontrada</p>
        <!-- <p><img :src="'generic/    reportesSindatos.png' | baseImg"></p> -->
      </header>
      <p class="error-advise">PARECE QUE ESTA PÁGINA NO EXISTE, TAL VEZ QUIERAS IR AL INICIO</p>
      <a class="btn btn-primary btn-round" href="/">IR AL INICIO</a>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.page-content {
    text-align: center;
    margin: 0 auto;
    display: block;
}
header {
    img {
        opacity: .6;
    }
    h1 {
        font-size: 10em;
        font-weight: 400;
    }
    p {
        margin-bottom: 30px;
        font-size: 30px;
        text-transform: uppercase;
    }
}
</style>